(() => {
  const desktopHero = window.matchMedia('(min-width: 1101px)');

  const initFeatureCardHeight = (scope = document) => {
    scope.querySelectorAll('.tab-hero__grid--with-stream').forEach((grid) => {
      if (grid.dataset.tabFeatureHeightReady === 'true') return;

      const featureCard = grid.querySelector('.tab-hero__card');
      const streamCard = grid.querySelector('.tab-stream-card');
      if (!featureCard || !streamCard) return;

      grid.dataset.tabFeatureHeightReady = 'true';
      let animationFrame;
      let observer;

      const syncHeight = () => {
        window.cancelAnimationFrame(animationFrame);
        featureCard.style.removeProperty('height');

        if (!desktopHero.matches) return;

        animationFrame = window.requestAnimationFrame(() => {
          const featureTop = featureCard.getBoundingClientRect().top;
          const streamBottom = streamCard.getBoundingClientRect().bottom;
          const targetHeight = Math.max(0, Math.round(streamBottom - featureTop));

          featureCard.style.height = `${targetHeight}px`;
        });
      };

      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(syncHeight);
        observer.observe(grid.querySelector('.tab-hero__copy'));
        observer.observe(streamCard);
      }

      desktopHero.addEventListener('change', syncHeight);
      window.addEventListener('resize', syncHeight, { passive: true });
      grid.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', syncHeight, { once: true });
      });

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeight);
      grid.tabFeatureHeightCleanup = () => {
        window.cancelAnimationFrame(animationFrame);
        if (observer) observer.disconnect();
        desktopHero.removeEventListener('change', syncHeight);
        window.removeEventListener('resize', syncHeight);
      };
      syncHeight();
    });
  };

  const initStreamModals = (scope = document) => {
    scope.querySelectorAll('[data-tab-stream-modal]').forEach((modal) => {
      if (modal.dataset.tabStreamReady === 'true') return;
      modal.dataset.tabStreamReady = 'true';

      const modalId = modal.id;
      const video = modal.querySelector('video');
      const openers = document.querySelectorAll(`[data-tab-stream-open="${modalId}"]`);
      const closeButton = modal.querySelector('[data-tab-stream-close]');

      const openModal = () => {
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }

        if (video) video.play().catch(() => {});
      };

      const closeModal = () => {
        if (video) video.pause();

        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      };

      openers.forEach((opener) => opener.addEventListener('click', openModal));
      if (closeButton) closeButton.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      modal.addEventListener('close', () => {
        if (video) video.pause();
      });
    });
  };

  initFeatureCardHeight();
  initStreamModals();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      initFeatureCardHeight(event.target);
      initStreamModals(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.tab-hero__grid--with-stream').forEach((grid) => {
        if (grid.tabFeatureHeightCleanup) grid.tabFeatureHeightCleanup();
      });
    });
  }
})();
